import type {
	ICPDocumentCheckingParagraph,
	ICPQuestionChangeHistorySidebarData
} from '~/portal/components/pages'

export interface ICPDocumentCheckingCheckboxAnswer {
	id: number
	value: string
	textMark: string | null
	order: number
}

export enum ECP_QUESTION_STATUS {
	Empty = 'EMPTY',
	Checked = 'CHECKED',
	Unchecked = 'UNCHECKED',
	Returned = 'RETURNED',
	NotRelevant = 'NOT_RELEVANT',
	SavedNotSend = 'SAVED_NOT_SENT'
}

export interface ICPDocumentCheckingQuestionFormData {
	question: number
	status?: string
	comment?: string
	blocks: {
		id: number
		type: string
		label?: string
		answer?: any
		answers?: ICPDocumentCheckingCheckboxAnswer[]
		subtype?: string
		isReferent: boolean
		isRequired: boolean
		textMark?: string | null
		reference?: {
			canBeEdited: boolean
			source: string
		}
	}[]
}

export type ICPDocumentCheckingQuestionFormDataList = Record<
	number,
	Record<number, ICPDocumentCheckingQuestionFormData>
>
export interface ICPDocumentCheckingQuestionHint {
	title: string
	link?: string
	file?:
		| {
				file_key: string
				name: string
		  }[]
		| File[]
		| null
}
export interface ICPDocumentCheckingQuestion {
	id: number
	index: string
	order: number
	title: string
	hint?: ICPDocumentCheckingQuestionHint
	internalHint?: ICPDocumentCheckingQuestionHint
	isConditional?: boolean
	containsNewSavedAnswers?: boolean
	blocks: {
		id: number
		type: string
		subtype?: string
		label?: string
		answer?: string | number[] | null
		answers?: ICPDocumentCheckingCheckboxAnswer[]
		isReferent: boolean
		isRequired: boolean
		textMark?: string | null
		reference?: {
			canBeEdited: boolean
			source: string
		}
	}[]
	status?: ECP_QUESTION_STATUS
	comment?: {
		id: number
		value: string
	}
	lastUpdate?: {
		date: string
		name: string
		action: string
	}
	allowEditOwnComment?: boolean
	comments?: {
		id: string
		text: string
		textMark: string
	}[]
	preDefinedComments?: number[]
	ownComment?: string | null
	actionLog?: ICPQuestionChangeHistorySidebarData[]
}

export interface ICPDocumentCheckingQuestionInpectionPayload {
	id: number
	status?: ECP_QUESTION_STATUS
	comment?: {
		id?: number
		value: string
	}
}
export interface ICPDocumentCheckingQuestionListProps {
	paragraphs: ICPDocumentCheckingParagraph[]
	iteration: number
	isInternal: boolean
	showInfoBanner: boolean
	showIteration: boolean
	disabled?: boolean
	status?: string
}
